import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class ReglasPublicacionService extends ApiService {
  entityType = EntityType.REGLA_PUBLICACION;
  url = 'api/reglas-publicacion/';
}
